import FetchStatusRepository   from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyMessage           from "../../../domain/fundamentals/message/notify/NotifyMessage";
import NotifyRepository        from "../../../domain/fundamentals/message/notify/NotifyRepository";
import NotifyType              from "../../../domain/fundamentals/message/notify/NotifyType";
import { ApiClient }           from "../../../infrastructure/configure/ApiClientConfig";
import FetchStatusDataSource   from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource        from "../../../infrastructure/datasource/notify/NotifyDataSource";
import RouterDispatcher        from "../../../infrastructure/redux/router/RouterDispatcher";
import SetValidateErrorMessage from "../error/SetValidateErrorMessage";

class RegisterPayJpCustomerToken {
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);
  private readonly setValidateErrorMessage: SetValidateErrorMessage = new SetValidateErrorMessage(this.dispatch);
  private readonly routerDispatcher: RouterDispatcher = new RouterDispatcher(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(token: string) {
    this.fetchStatusRepository.start();
    try {
      await ApiClient.post("/payment/token", {
        token: token,
      });

      this.routerDispatcher.paymentComplete();
    } catch (e) {
      this.notifyRepository.optionalMessage(NotifyType.OPTIONAL_FAILURE, new NotifyMessage("決済情報が確認できませんでした。"));
      this.setValidateErrorMessage.execute(e);
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default RegisterPayJpCustomerToken;
